import {Injectable} from 'ng-metadata/core';
import {UserSessionManagerService} from  '../../../security/userSessionManager.service';


@Injectable()
export class AuthenticationService {
    constructor(private userSessionManagerService: UserSessionManagerService) {
    }
    handleLogout() {
        this.userSessionManagerService.logout(false);
    }

}
//put here all angular1 modules the service is using
export default [];


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/topbar/userArea/authentication.service.ts